import { useRef } from 'react';
import useScrollAnimation from '../../hooks/useScrollAnimation';
import './booking-card.css';

const BookingCard = () => {
    const cardDetailsRef = useRef(null);
    const cardTitleRef = useRef(null);

    useScrollAnimation([cardDetailsRef, cardTitleRef]);

    return (
        <div className="booking-card">

            <div ref={cardDetailsRef} className='booking-card-div animate-on-scroll'>
                <div className='inner-div'>
                    <p className='time-title'>Working Time</p>

                    <div className='time-main-div'>
                        <div className='time-div'>
                            <p>Monday - Saturday</p>
                            <p>9:30 am - 9:30 pm</p>
                        </div>
                        <div className='time-div'>
                            <p>Sunday</p>
                            <p>9:30 am - 9:00 pm</p>
                        </div>
                    </div>
                </div>
                <div className='inner-div'>
                    <p className='time-title'>Contact</p>
                    <p className='time-div'> 099091 02266</p>
                </div>
            </div>

            <div ref={cardTitleRef} className='book-title-div animate-on-scroll'>

                <p className='booking-title'>Book an Appointment</p>
                <div className='separator-div'>
                    <div className='separator-line'></div>
                    <div className='separator-line'></div>
                </div>
            </div>
        </div>
    );
};

export default BookingCard;
